import { AnalyticsFilterDefaultValues } from 'front-end/src/pages/analytics/AnalyticsContext'
import React from 'react'
import { Trans } from '@lingui/macro'
import IconDocEnrolment from '../../components/common/icon/IconDocEnrolment'
import IconPeople from '../../components/common/icon/IconPeople'
import IconDoc from '../../components/common/icon/IconDoc'
import IconMagnifier from '../../components/common/icon/IconMagnifier'
import { staticLinks } from 'shared/linkBuilder'
import IconBadge from '../../components/common/icon/IconBadge'
import { useAnalyticsNavPanelQuery } from './AnalyticsNavPanel.codegen'
import IconMap from '../../components/common/icon/IconMap'
import { useFeatureFlags } from '../../app/hooks/useFeatureFlags'
import { useLocation } from 'react-router-dom'
import { Box, Flex, LinkOverlayWithQuery } from 'front-end/src/components'
import IconPlay from 'front-end/src/components/common/icon/IconPlay'
import { fontSizes } from 'front-end/src/components/chakraThemeExtension'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'

export function AnalyticsNavPanel() {
  const { userIsAdminOrManager } = usePublicApiSession()
  const { featureFlags } = useFeatureFlags()

  // remove
  const { data } = useAnalyticsNavPanelQuery({
    fetchPolicy: 'cache-first',
    skip: userIsAdminOrManager
  })

  const adminOrGroupAdmin = userIsAdminOrManager || data?.me.isAdminOfSomeGroup
  const { search: searchParam } = useLocation()

  const getSearchWithDefaultPageAndSearch = () => {
    const params = new URLSearchParams(searchParam)
    params.set('page', `${AnalyticsFilterDefaultValues.page}`)
    params.set('search', AnalyticsFilterDefaultValues.search)
    return params.toString()
  }

  const getPathUrl = (pathname) => {
    return {
      pathname,
      search: getSearchWithDefaultPageAndSearch()
    } as any
  }

  return (
    <Flex className={`analytics-nav panel-nav`} align="center">
      <Box fontSize={fontSizes.xl}>
        <Trans>Analytics</Trans>
      </Box>
      <div className="panel-nav-options" data-test="TabList">
        <LinkOverlayWithQuery
          className="option"
          activeClassName="active"
          role="tab"
          to={getPathUrl(staticLinks.analyticsPeople)}
        >
          <IconPeople />
          <span className="label clickable">
            <Trans>People</Trans>
          </span>
          <span className="option-active" />
        </LinkOverlayWithQuery>
        <LinkOverlayWithQuery
          className="option"
          activeClassName="active"
          role="tab"
          to={getPathUrl(staticLinks.analyticsResources)}
        >
          <IconDoc />
          <span className="label clickable">
            <Trans>Resources</Trans>
          </span>
          <span className="option-active" />
        </LinkOverlayWithQuery>
        <LinkOverlayWithQuery
          className="option"
          activeClassName="active"
          role="tab"
          to={getPathUrl(staticLinks.analyticsWorkbooks)}
        >
          <IconDocEnrolment />
          <span className="label clickable">
            <Trans>Enrolments</Trans>
          </span>
          <span className="option-active" />
        </LinkOverlayWithQuery>
        {adminOrGroupAdmin && (
          <LinkOverlayWithQuery
            className="option"
            activeClassName="active"
            role="tab"
            to={getPathUrl(staticLinks.analyticsPathways)}
          >
            <IconMap />
            <span className="label clickable">
              <Trans>Pathways</Trans>
            </span>
            <span className="option-active" />
          </LinkOverlayWithQuery>
        )}
        {adminOrGroupAdmin && featureFlags?.certificates && (
          <LinkOverlayWithQuery
            className="option"
            activeClassName="active"
            role="tab"
            to={getPathUrl(staticLinks.analyticsCertifications)}
          >
            <IconBadge />
            <span className="label clickable">
              <Trans>Certifications</Trans>
            </span>
            <span className="option-active" />
          </LinkOverlayWithQuery>
        )}
        {userIsAdminOrManager && featureFlags?.video_analytics && (
          <LinkOverlayWithQuery
            className="option"
            activeClassName="active"
            role="tab"
            to={getPathUrl(staticLinks.analyticsMedia)}
          >
            <IconPlay />
            <span className="label clickable">
              <Trans>Media</Trans>
            </span>
            <span className="option-active" />
          </LinkOverlayWithQuery>
        )}
        {userIsAdminOrManager && (
          <LinkOverlayWithQuery
            className="option"
            activeClassName="active"
            role="tab"
            to={getPathUrl(staticLinks.analyticsSearch)}
          >
            <IconMagnifier />

            <span className="label clickable">
              <Trans>Search</Trans>
            </span>
            <span className="option-active" />
          </LinkOverlayWithQuery>
        )}
      </div>
    </Flex>
  )
}
